const closeFlow = () => {
  const elements = document.getElementsByClassName('close-flow');
  elements.length && elements[0].click();
};

export default closeFlow;
